export const RequestStatus_External = "External";
export const RequestStatus_Submitted = "Submitted";
export const RequestStatus_Reviewing = "Reviewing";
export const RequestStatus_Approved = "Approved";
export const RequestStatus_Rejected = "Rejected";
export const RequestStatus_CovidPositive = "Covid Positive";
